const JsonSearch = require('json-search');
import Render from './Render.js';
import Editor from './Editor.js';
import { Actions, Store, Flummox } from 'flummox';
import SectionActions from './flux/SectionActions.js';
import SectionStore from './flux/SectionStore.js';
import DiffJson from 'diff-json';
import Immutable from 'immutable';
import Config from 'config';
import Login from './Login.js';
import Subscription from './Subscription.js';
import Payment from './Payment.js';
import AddonsPayment from './AddonsPayment.js';
import Register from './Register.js';
import scrollMonitor from 'scrollmonitor';
import Menu from './renderers/Menu';
import Search from './Search';
import AuthDataStorage from './AuthDataStorage';

class Flux extends Flummox {
  constructor(fileName, editor) {
    super();
    this.createActions('sections', SectionActions);
    this.createStore('sections', SectionStore, this, fileName, editor);
  }
}

let flux, paginateMore;

const RenderSection = (path, data) => {
  let lastPath = path.slice(-1)[0];
  let parentElement = document.querySelectorAll(
                        '[data-cms-render="' + lastPath + '"]')[0];

  let renderSection = new Render({element: parentElement, data, flux, path});
};

const RenderSections = (section, path) => {
  path = (path.constructor === Array) ? path : [path];

  if (section.get("sections")) {
    return section.get("sections").forEach((section, childPath) => {
      path.push(childPath);
      RenderSections(section, path);
    });
  }

  if (path.length > 1) {
    path.splice(1, 0, "sections");
  }

  let originalPath = path.slice(0);
  path.splice(0,0, "previousSections");
  let previousSection = flux._stores.sections.state.getIn(path);

  if (!previousSection) {
    RenderSection(originalPath, section);
  }
}

let textStyles = {
  "activeDS" : "activ<span>DS</span>"
}

let pageSections, editor;

const findByTag = (tagName) => {
  let elementData = JSON.search(pageSections, tagName);

  if (elementData.length === 1) {
    return pageSections['sections'][[Object.keys(elementData[0].chain.sections)[0]]];
  }

  return false;
}

const loadElement = (element, data) => {
  if (!data) {
    element.className += " " + element.dataset.cmsRender;
    data = findByTag(element.dataset.cmsRender);

    if (data.type !== "container") {
      flux.getActions('sections').addSection(element.dataset.cmsRender, data);
    } else {
      ContainerRender(element, data.sections);
    }
  }
}

const ContainerRender = (element, sections) => {
  sections.forEach((section) => {
    let div = document.createElement("div");
    div.className = section.tags[0] + " span12";
    div.dataset.cmsRender = section.tags[0];
    element.appendChild(div);
    flux.getActions('sections').addSection(element.dataset.cmsRender + " " + section.tags[0], section);
  });
}

const loadCMS = (response) => {
  pageSections = JSON.parse(response);
  if (editor) Editor(flux, pageSections);

  let elements = document.querySelectorAll('[data-cms-render]');

  for (let i = 0; i < elements.length; i++) {
    loadElement(elements[i]);
  }
}

const updateSection = (response, data) => {
  let newData = JSON.parse(response);

  let foundKey = false, foundData = false;

  flux._stores.sections.state.get('sections').forEach((section, key) => {
    if (section.get(data.subContent)) {
      foundKey = key;
      foundData = section.toJS();
    }
  });

  newData.sections.forEach((section, index) => {
    if (section[data.subContent]) {
      if (section[data.subContent].length > 0) {
        section[data.subContent].forEach((post, index) => {
          foundData[data.subContent].push(post);
        });
      } else {
        paginateMore = false;
      }
    }
  });

  flux.getActions('sections').updateSection(foundKey, foundData);
}

const setupLogin = () => {
  let loginButtons = document.getElementsByClassName('login-action');

  let login = new Login({loginButtons});
}

const setupSubscription = () => {
  let statusElement = document.getElementsByClassName('subscription-status')[0];

  let subscription = new Subscription({statusElement});
}

const setupPaginate = (data, callback) => {
  var footerEl = document.getElementsByClassName("footer")[0];

  var elementWatcher = scrollMonitor.create( footerEl );
  let inProgress = false;
  paginateMore = true;

  elementWatcher.enterViewport(function() {
    if (!inProgress && paginateMore) {
      var xobj = new XMLHttpRequest();
      data.page++;
      xobj.overrideMimeType("application/json");
      xobj.open("POST", Config.BACKEND_URL + '/getpage?t=' + Math.floor(Date.now() / 1000));
      xobj.onreadystatechange = function () {
        if (xobj.readyState == 4) {
          if (xobj.status == "200") {
            // Required use of an anonymous callback as .open will NOT return a value
            // but simply returns undefined in asynchronous mode
            updateSection(xobj.responseText, data);
          }
        }
      };
      xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xobj.send(JSON.stringify(data));
    }
  });
}

const loadJSON = (callback) => {
  let cmsloader = document.getElementById('cmsloader');

  let loaderQuery = cmsloader.src.replace(/^[^\?]+\??/,'').split("&");
  let dataFile, paginate = false, limit = false, subContent, orderby, elementIndex = -1;

  loaderQuery.forEach((queryString) => {
    if (queryString.indexOf("data=") === 0) {
      dataFile = queryString.substr(5);
    }

    if (queryString.indexOf("paginate=") === 0) {
      paginate = queryString.substr(9);
    }

    if (queryString.indexOf("subContent=") === 0) {
      subContent = queryString.substr(11);
    }

    if (queryString.indexOf("limit=") === 0) {
      limit = queryString.substr(6);
    }

    if (queryString.indexOf("orderby=") === 0) {
      orderby = queryString.substr(8);
    }
  });

  let queryStrings = window.location.search.substr(1).split("&");

  queryStrings.forEach((queryString) => {
    if (queryString.indexOf("editor=") === 0) {
      editor = queryString.substr(7) === "true" ? true : false;
    }
    if (queryString.indexOf("idx=") === 0) {
      elementIndex = Number(queryString.substr(4));
    }
  });

  if (elementIndex > -1) {
    paginate = false;
  }

  flux = new Flux(dataFile, editor);

  flux._stores.sections.on('change', () => {
    flux._stores.sections.state.get('sections').forEach(RenderSections);
  });

  let data = {
    file: dataFile,
    page: 0,
    limit,
    subContent,
    paginate,
    orderby,
    elementIndex
  };

  var xobj = new XMLHttpRequest();
  xobj.overrideMimeType("application/json");
  xobj.open("POST", Config.BACKEND_URL + '/getpage?t=' + Math.floor(Date.now() / 1000));
  xobj.onreadystatechange = function () {
    if (xobj.readyState == 4 && xobj.status == "200") {
      // Required use of an anonymous callback as .open will NOT return a value
      // but simply returns undefined in asynchronous mode
      callback(xobj.responseText);
      setupLogin();
      setupSubscription();

      if (paginate) setupPaginate(data, callback);
    }
  };
  xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

  xobj.send(JSON.stringify(data));
}

const setupMenu = (callback) => {
  let data = {
    file: 'data/Menu.json'
  };
  var xobj = new XMLHttpRequest();
  xobj.overrideMimeType("application/json");
  xobj.open("POST", Config.BACKEND_URL + '/getpage?t=' + Math.floor(Date.now() / 1000));
  xobj.onreadystatechange = function () {
    if (xobj.readyState == 4 && xobj.status == "200") {
      var menuData = JSON.parse(xobj.response);
      var headerMenu = document.querySelectorAll('[data-menu-render="header"]');

      let headerMenuInstance = new Menu({parentElement: headerMenu[0],
                                                  data: menuData.sections[0]});

      let footerMenu = document.querySelectorAll('[data-menu-render="footer"]');

      let footerMenuInstnace = new Menu({parentElement: footerMenu[0],
                                                  data: menuData.sections[1]});

      let search = new Search();

      callback();
    }
  };
  xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

  xobj.send(JSON.stringify(data));
}

const loadUserDataFromServer = function (callback) {
  let authDataStorage = new AuthDataStorage();
  authDataStorage.refreshDataFromServer(function () {
    if (typeof callback == 'function') {
      callback.call(this);
    }
  }.bind(this));
};

window.onload = () => {
  loadUserDataFromServer(() => {
    if (window.location.href.indexOf("payment.html") > -1) {
      setupMenu(() => {
        setupLogin();
        if (window.location.href.indexOf("id=") === -1) {
          let payment = new Payment();
        } else {
          let payment = new AddonsPayment();
        }
      });
    } else if (window.location.href.indexOf("register.html") > -1) {
      setupMenu(() => {
        setupLogin();
        let register = new Register();
      });
    } else {
      setupMenu(() => {
        loadJSON(loadCMS);
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/CMSLoader.js